import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ViewTicketPage.module.css";
import { Home } from "@mui/icons-material";
import Button from "@components/Button";
import { useLocation } from "react-router";

const ViewTicketPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const ticket = location.state?.stages || {};
    const ticketData = Array.isArray(ticket.stages) ? ticket.stages : [];
    console.log("Ticket Data:", ticketData);
    console.log("Ticket:", ticket);

    const handleNavigateDashboard = () => {
        navigate("/");
    };
    
    const handleNavigateTicketSupport = () => {
        navigate("/ticketsupport");
    };

    return (
        <>
            <div className={styles.MenuWrapper}>
                <div className={styles.NavigationWrapper}>
                    <Home className={styles.HomeIcon} onClick={handleNavigateDashboard} />
                    <div>
                        <span className={styles.DashboardText} onClick={handleNavigateDashboard}>
                            Dashboard
                        </span>
                        <span className={styles.DashboardText} onClick={handleNavigateTicketSupport}>
                            /Ticket Support
                        </span>
                        <span className={styles.RouteText}> /View Ticket</span>
                    </div>
                </div>
                <Button
                    className={styles.BtnClass}
                    text={"Back"}
                    btnType="secondary"
                    onClick={handleNavigateTicketSupport}
                />
            </div>
            
            <div className={styles.container}>
                <div className={styles.leftSection}>
                    <h2 className={styles.title}>Ticket Details</h2>
                    <br/>
                    <div className={styles.ticketInfo}>
                        <p><strong>Name:</strong> {ticket.firstName} {ticket.lastName}</p>
                        <p><strong>Issue Type:</strong> {ticket.issueType}</p>
                        <p><strong>User Type:</strong> {ticket.userType}</p>
                        <p><strong>Source:</strong> {ticket.source}</p>
                        <p><strong>Message:</strong> {ticket.message}</p>
                        <p><strong>Contact:</strong> {ticket.contact}</p>
                        <p><strong>Registered Email:</strong> {ticket.registeredEmail}</p>
                    </div>
                </div>
                <div className={styles.divider}></div>
                <div className={styles.timeline}>
                    {ticketData.map((ticket, index) => (
                        <div key={index} className={styles.timelineItem}>
                            <div className={styles.circle}></div>
                            <div className={styles.content}>
                                <p className={styles.status}>to: <strong>{ticket.to}</strong></p>
                                <p>Comment: {ticket.comment}</p>
                                <p>Assignee ID: {ticket.assigneeId}</p>
                                <p>First Name: {ticket.assigneeFirstName}</p>
                                <p>Last Name: {ticket.assigneeLastName}</p>
                                <p>Email: {ticket.assigneeEmail}</p>
                                <p>Date: {ticket.date}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default ViewTicketPage;
